var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { memo, useEffect, useCallback, useState, useRef } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import NavSelect from './nav_select';
var Nav = function () {
    var item = useSelector(function (state) { return state.product.item; });
    var category = useSelector(function (state) { return state.common.category; });
    var categoryData = useSelector(function (state) { return state.common.categoryData; });
    var _a = useState([]), currentArr = _a[0], setCurrentArr = _a[1];
    var _b = useState(''), currentCategory = _b[0], setCurrentCategory = _b[1];
    var _c = useState(-1), onLayerIndex = _c[0], setOnLayerIndex = _c[1];
    var currentIdIsStdpc = category && currentCategory.slice(0, 1) === '2' || false;
    var _d = useState(0), prevId = _d[0], setPrevId = _d[1];
    var _e = useState(0), prevIndex = _e[0], setPrevIndex = _e[1];
    var timerRef = useRef(null);
    var setIdFn = function (val) { return setPrevId(val); };
    var setIndexFn = function (val) { return setPrevIndex(val); };
    var prevDataZeroSettingFn = function () {
        setIdFn(0);
        setIndexFn(0);
    };
    var prevDataSetting = function (dataType) {
        if (dataType === 'mouseLeave') {
            prevDataZeroSettingFn();
            setCurrentCategory(prevId.toString());
            setOnLayerIndex(-1);
        }
        if (dataType === 'default') {
            prevDataZeroSettingFn();
            setCurrentCategory(prevId.toString());
            setOnLayerIndex(-1);
        }
    };
    var categoryAction = function (timer, type) {
        timerOnFn(timer, type);
    };
    var timerOnFn = function (timer, dataType) {
        timerRef.current = setTimeout(function () {
            prevDataSetting(dataType);
        }, timer);
    };
    var timerOffFn = function () {
        if (timerRef.current !== null) {
            clearTimeout(timerRef.current);
            timerRef.current = null;
        }
    };
    var flagIdIndexFn = function () {
        return !!(prevId && prevIndex);
    };
    var zeroChild = useCallback(function (arr, cate_id) {
        if (!arr)
            return [];
        var deleteChild = arr.map(function (v) {
            return __assign(__assign({}, v), { child: cate_id === v.cate_id ? v.child : [] });
        });
        return deleteChild;
    }, []);
    var cateIdArr = useCallback(function () {
        var _a, _b;
        var arr = [];
        var isCate0;
        if (((_a = categoryData[currentCategory]) === null || _a === void 0 ? void 0 : _a.f_cate_0) === undefined) {
            return [];
        }
        if (category && currentCategory.slice(0, 1) === '2') {
            return category;
        }
        if (category && currentCategory.slice(0, 1) !== '2') {
            isCate0 = ((_b = categoryData[currentCategory]) === null || _b === void 0 ? void 0 : _b.f_cate_0) === 1 || currentCategory.slice(0, 1) === '2';
            arr = [categoryData[currentCategory][isCate0 ? 'cate_id' : 'cate_id_0']];
        }
        if (isCate0) {
            return arr;
        }
        for (var i = 7; i > 1; i -= 2) {
            var reg = new RegExp(".{".concat(i, "}$"));
            var ca = currentCategory.toString().replace(reg, '0'.repeat(i));
            arr.push(ca);
            if (currentCategory.toString() === ca) {
                break;
            }
        }
        return arr;
    }, [categoryData, currentCategory]);
    var currentArrFunc = useCallback(function () {
        var cateArr = cateIdArr();
        var set = [];
        if (cateArr.length === 0) {
            var obj = {
                index: 0,
                cate_id: null,
                cate_name: '선택하세요',
                child: zeroChild(category, 1),
            };
            set.push(obj);
        }
        else {
            cateArr.forEach(function (item, i) {
                var _a, _b, _c;
                var cateObj = {};
                if (!currentIdIsStdpc) {
                    cateObj = {
                        index: i,
                        cate_id: cateArr[i],
                        cate_name: categoryData[cateArr[i]].cate_name,
                        child: i === 0
                            ? zeroChild(category, cateArr[i])
                            : zeroChild((_b = (_a = set[i - 1]) === null || _a === void 0 ? void 0 : _a.child.find(function (v) { return v.cate_id === cateArr[i - 1]; })) === null || _b === void 0 ? void 0 : _b.child, cateArr[i]),
                    };
                }
                if (currentIdIsStdpc) {
                    cateObj = {
                        index: i,
                        cate_id: cateArr[i].cate_id,
                        cate_name: cateArr[i].child.find(function (v) { return v.cate_id.slice(0, 3) === currentCategory.slice(0, 3); }).cate_name,
                        child: i === 0
                            ? category && category[0].child
                            : cateArr[i].child,
                    };
                }
                set.push(cateObj);
                if (i === cateArr.length - 1) {
                    var child = currentIdIsStdpc ? cateObj.child : (_c = cateObj.child.find(function (v) { return v.cate_id === cateArr[i]; })) === null || _c === void 0 ? void 0 : _c.child;
                    if (!child || child.length === 0)
                        return;
                    var cateIdIsStdPc = child.find(function (v) { return v.cate_id.slice(0, 3) === currentCategory.slice(0, 3); });
                    var twoDepthIsStapc = void 0;
                    var lastObj = {};
                    if (currentIdIsStdpc) {
                        twoDepthIsStapc = cateIdIsStdPc.child.find(function (v) { return v.cate_id === currentCategory; });
                        if (!cateIdIsStdPc.child || cateIdIsStdPc.child.length === 0)
                            return;
                        lastObj = {
                            index: i + 1,
                            cate_id: null,
                            cate_name: twoDepthIsStapc ? twoDepthIsStapc.cate_name : '선택하세요',
                            child: cateIdIsStdPc.child,
                        };
                    }
                    if (!currentIdIsStdpc) {
                        lastObj = {
                            index: i + 1,
                            cate_id: null,
                            cate_name: '선택하세요',
                            child: child,
                        };
                    }
                    set.push(lastObj);
                }
            });
        }
        setCurrentArr(set);
        flagIdIndexFn() && categoryAction(2000, 'default');
    }, [item, category, currentCategory]);
    useEffect(function () {
        if (item) {
            setCurrentCategory(item.cate_id.toString());
        }
    }, [item]);
    useEffect(function () {
        if (category && currentCategory) {
            currentArrFunc();
        }
    }, [category, currentCategory]);
    return (React.createElement(Style, null, category && currentCategory && (React.createElement("ul", { className: "nav_ul" },
        React.createElement("li", null,
            React.createElement("span", { className: "txt" }, "\uD648")),
        currentArr.map(function (v, i) { return (React.createElement(NavSelect, { key: v.cate_id, data: v, index: v.index, onLayerIndex: onLayerIndex, setOnLayerIndex: setOnLayerIndex, setCurrentCategory: setCurrentCategory, setIdFn: setIdFn, setIndexFn: setIndexFn, prevDataSetting: prevDataSetting, currentCategory: currentCategory, timerOffFn: timerOffFn, flagIdIndexFn: flagIdIndexFn, prevId: prevId, prevIndex: prevIndex })); })))));
};
var Style = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n    display: flex;\n    justify-content: space-between;\n    height: 39px;\n    padding: 0 0 14px;\n    margin: 20px 0 20px;\n    border-bottom: 2px solid #333;\n    font-size: 12px;\n    z-index: 10;\n\n    .nav_ul {\n        display: flex;\n\n        & > li {\n            position: relative;\n\n            & + li:before {\n                font-family: 'ppingkr_v4';\n                content: '\\e906';\n                color: #999;\n            }\n            a,\n            button {\n                &:hover {\n                    color: #418ded;\n                }\n            }\n            &.active {\n                .nav_layer {\n                    display: block;\n                }\n                .arrow {\n                    &:after {\n                        color: #418ded;\n                        transform: rotate(180deg);\n                        border-color: #418ded;\n                    }\n                }\n            }\n        }\n    }\n    .txt {\n        color: #333;\n        padding: 0 8px 5px;\n        white-space: nowrap;\n\n        &.arrow {\n            cursor: pointer;\n\n            &:after {\n                display: inline-flex;\n                justify-content: center;\n                align-items: center;\n                margin: 0 0 0 5px;\n                width: 18px;\n                height: 18px;\n                border: 1px solid #ccc;\n                font-family: 'ppingkr_v4';\n                content: '\\e904';\n                box-sizing: border-box;\n            }\n        }\n    }\n    .nav_layer {\n        position: absolute;\n        top: 20px;\n        left: 10px;\n        border: 1px solid #333;\n        background: #fff;\n        padding: 5px 9px;\n        white-space: nowrap;\n\n        li {\n            a,\n            button {\n                color: #333;\n                line-height: 20px;\n            }\n            &.active {\n                a,\n                button {\n                    color: #418ded;\n                    font-weight: 700;\n                }\n            }\n        }\n    }\n"], ["\n    position: relative;\n    display: flex;\n    justify-content: space-between;\n    height: 39px;\n    padding: 0 0 14px;\n    margin: 20px 0 20px;\n    border-bottom: 2px solid #333;\n    font-size: 12px;\n    z-index: 10;\n\n    .nav_ul {\n        display: flex;\n\n        & > li {\n            position: relative;\n\n            & + li:before {\n                font-family: 'ppingkr_v4';\n                content: '\\\\e906';\n                color: #999;\n            }\n            a,\n            button {\n                &:hover {\n                    color: #418ded;\n                }\n            }\n            &.active {\n                .nav_layer {\n                    display: block;\n                }\n                .arrow {\n                    &:after {\n                        color: #418ded;\n                        transform: rotate(180deg);\n                        border-color: #418ded;\n                    }\n                }\n            }\n        }\n    }\n    .txt {\n        color: #333;\n        padding: 0 8px 5px;\n        white-space: nowrap;\n\n        &.arrow {\n            cursor: pointer;\n\n            &:after {\n                display: inline-flex;\n                justify-content: center;\n                align-items: center;\n                margin: 0 0 0 5px;\n                width: 18px;\n                height: 18px;\n                border: 1px solid #ccc;\n                font-family: 'ppingkr_v4';\n                content: '\\\\e904';\n                box-sizing: border-box;\n            }\n        }\n    }\n    .nav_layer {\n        position: absolute;\n        top: 20px;\n        left: 10px;\n        border: 1px solid #333;\n        background: #fff;\n        padding: 5px 9px;\n        white-space: nowrap;\n\n        li {\n            a,\n            button {\n                color: #333;\n                line-height: 20px;\n            }\n            &.active {\n                a,\n                button {\n                    color: #418ded;\n                    font-weight: 700;\n                }\n            }\n        }\n    }\n"])));
export default memo(Nav);
var templateObject_1;



//////////////////
// WEBPACK FOOTER
// ./src/detail/components/nav/index.tsx
// module id = 176
// module chunks = 0